/**
 * Who the challenge features are for.
 *
 * The five departments challenges are set against — the four tutoring projects
 * plus OGD — and Finance, who administer them.
 *
 * Finance was originally left out on the grounds that a targets badge would
 * always read zero for them. That reasoning no longer holds: the badge renders
 * whether or not there is a challenge, because it is the only route into
 * Interval Targets, and Finance are the people most likely to want the full
 * view. Their own progress is still empty; the door is the point.
 *
 * Department comes from the stored profile, which the portal resolves through
 * the wing chain (user -> user_roles -> usertype -> designations -> wing).
 */
export const CHALLENGE_SCOPE_DEPT_IDS = [
  3, // Project-Foundation
  20, // Project-Classroom
  21, // Project-Little Genie
  22, // Project-Speak Pro
  11, // Operations Growth Department (OGD)
];

export const FINANCE_DEPT_ID = 7;

/** Whether challenges are ever set against this department. */
export function isInChallengeScope(departmentId) {
  return CHALLENGE_SCOPE_DEPT_IDS.includes(Number(departmentId));
}

/**
 * TEMPORARY — the badge is switched off for staff (2026-09-14).
 *
 * Interval Targets goes live for Finance first: they check the figures against
 * their own records on real data before anyone is shown a number about their own
 * performance. A wrong target in front of a CRO is far more expensive to undo
 * than a wrong target in front of the person who set it.
 *
 * TO SWITCH THE BADGE BACK ON: set this to false. Nothing else to change.
 */
const STAFF_BADGE_OFF = false;

/** Whether this person gets the toolbar badge and the way into Interval Targets. */
export function canOpenTargets(departmentId) {
  if (STAFF_BADGE_OFF) return false;
  return isInChallengeScope(departmentId) || Number(departmentId) === FINANCE_DEPT_ID;
}
